export default __webpack_public_path__ + "static/AppMoneyWalkie2-104b3a9b56395242900d08402550500f.png";